import React, { useContext } from "react";
import { StateContext } from "../utils/context";
import { Link } from "react-router-dom";
import { isWhitePrimary } from "../utils/sidebarBrandingColors";
import { getBrandPrimaryColor } from "../utils/brandingThemeColor";

const DEFAULT_TEXT_COLOR = "var(--branding-theme-color, var(--theme-color, #2fbaad))";

const DeploymentCreditsBalance = ({ textColor = DEFAULT_TEXT_COLOR }) => {
	const { currentUser } = useContext(StateContext);
	const deploymentCredits = Number(currentUser?.deployment_credits) || 0;
	const resolvedColor =
		textColor === DEFAULT_TEXT_COLOR && isWhitePrimary(getBrandPrimaryColor())
			? "#000000"
			: textColor;
    return (
		<Link to="/deployment-credits">
            <div style={{display: "inline-flex"}}>
                <i className="mdi mdi-coin" style={{fontSize: '20px', color: resolvedColor, marginTop: "3px"}}></i>
                <div className="mt-1" style={{fontSize: "18px", color: resolvedColor, fontStyle: "normal", fontWeight: "bold"}}>&nbsp;{deploymentCredits} {deploymentCredits <= 1 ? 'Credit' : 'Credits' }</div>
            </div>
        </Link>
    );
}

export default DeploymentCreditsBalance;
